import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

const SHOPPING_ROAD_FIELDS = {
    seq: { type: parseInt, defaultValue: 0 },
    managerIdx: { type: parseInt, defaultValue: 0 },
    groupIdx: { type: Number, defaultValue: 0 },
    passIdx: { type: Number, defaultValue: 0 },
    openLevel: { type: Number, defaultValue: 50 },
    begin: { defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    memo: { defaultValue: '' },
    onOff: { type: Number, defaultValue: 0 },
}

export class ShoppingRoadEntity extends EntityBase{
    constructor(data = {}) {
        super(data, SHOPPING_ROAD_FIELDS);

        this.errors = [
            { condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.' },
            { condition: () => this.end < dayjs().unix(), message: '종료일이 현재 시간보다 이전입니다.' },
        ];
    }
}